import { ReactComponent as UsdtIcon } from "images/coins/usdtIconRound.svg";
import { ReactComponent as UsdcIcon } from "images/coins/usdcIconRound.svg";
import { ReactComponent as EthIcon } from "images/coins/ethIconRound.svg";
import { ReactComponent as TronIcon } from "images/coins/tronIconRound.svg";
import { ReactComponent as RubIcon } from "images/coins/rubIconRound.svg";


const icons = {
    USDT: <UsdtIcon />,
    USDC: <UsdcIcon />,
    ETH: <EthIcon />,
    TRX: <TronIcon />,
    RUB: <RubIcon />,
  };

export const getCurrencyIcon = (currency: string) => {
  return icons[currency as keyof typeof icons] || null;
};
